import { useEffect } from 'react';
import { useAppStore } from '@/app/store';
import { DEFAULT_BACKGROUND } from '@/storage/db';
import styles from './AppBackground.module.css';

export function AppBackground() {
  const backgroundUrl = useAppStore((s) => s.backgroundUrl);
  const bgPrefs = useAppStore((s) => s.preferences?.background ?? DEFAULT_BACKGROUND);

  useEffect(() => {
    const root = document.documentElement;
    const hasCustom = Boolean(backgroundUrl);

    root.style.setProperty('--has-custom-bg', hasCustom ? '1' : '0');
    root.style.setProperty(
      '--bg-image',
      backgroundUrl ? `url("${backgroundUrl}")` : 'none',
    );
    root.style.setProperty('--bg-position', `${bgPrefs.positionX}% ${bgPrefs.positionY}%`);

    if (hasCustom) {
      root.style.setProperty('--bg-dim', String(bgPrefs.dim));
      root.style.setProperty('--bg-blur', `${bgPrefs.blur}px`);
      root.style.setProperty('--surface-opacity', String(bgPrefs.surfaceOpacity));
      root.style.setProperty('--chrome-opacity', String(bgPrefs.surfaceOpacity));
      root.style.setProperty('--panel-opacity', String(Math.min(bgPrefs.surfaceOpacity, 0.88)));
      root.style.setProperty('--card-opacity', String(Math.min(bgPrefs.surfaceOpacity * 0.85, 0.72)));
    } else {
      root.style.setProperty('--bg-dim', '0.62');
      root.style.setProperty('--bg-blur', '0px');
      root.style.setProperty('--surface-opacity', '1');
      root.style.setProperty('--chrome-opacity', '1');
      root.style.setProperty('--panel-opacity', '1');
      root.style.setProperty('--card-opacity', '1');
    }
  }, [backgroundUrl, bgPrefs]);

  return (
    <div className={styles.root} aria-hidden="true">
      {backgroundUrl ? (
        <div className="app-background" />
      ) : (
        <div className={styles.defaultBg}>
          <svg className={styles.svg} viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
            <defs>
              <radialGradient id="twyme-g1" cx="30%" cy="20%" r="50%">
                <stop offset="0%" stopColor="#3d4a7a" stopOpacity="0.55" />
                <stop offset="100%" stopColor="#0d0e10" stopOpacity="0" />
              </radialGradient>
              <radialGradient id="twyme-g2" cx="75%" cy="65%" r="45%">
                <stop offset="0%" stopColor="#5a4a8a" stopOpacity="0.45" />
                <stop offset="100%" stopColor="#0d0e10" stopOpacity="0" />
              </radialGradient>
              <radialGradient id="twyme-g3" cx="55%" cy="35%" r="35%">
                <stop offset="0%" stopColor="#7b8cde" stopOpacity="0.18" />
                <stop offset="100%" stopColor="#0d0e10" stopOpacity="0" />
              </radialGradient>
            </defs>
            <rect width="1440" height="900" fill="#0A0B0D" />
            <ellipse cx="420" cy="180" rx="520" ry="380" fill="url(#twyme-g1)" />
            <ellipse cx="1080" cy="580" rx="480" ry="360" fill="url(#twyme-g2)" />
            <ellipse cx="780" cy="320" rx="320" ry="240" fill="url(#twyme-g3)" />
          </svg>
          <div className={styles.shapeA} />
          <div className={styles.shapeB} />
        </div>
      )}
      <div className="app-background-scrim" style={backgroundUrl ? undefined : { display: 'none' }} />
      {backgroundUrl && <div className="app-background-vignette" />}
    </div>
  );
}
